import { createLazyFileRoute, Outlet } from "@tanstack/react-router";

import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/runs")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <NavStackProvider label="Runs" href={{ to: "/runs" }}>
      <Outlet />
    </NavStackProvider>
  );
}
